/**
 * SistemicOutro — wrapper global de la cinta Sistemic.
 *
 * Decide DÓNDE se muestra (oculto en /acerca, donde ya está la
 * página completa de Sistemic). El render visual lo delega 100% a
 * SistemicMarquee, que tiene los tokens de marca scoped.
 *
 * Antes este archivo tenía el marquee inline ad-hoc. Se consolidó
 * en SistemicMarquee para estandarizar la identidad. Este wrapper
 * solo gobierna visibilidad por ruta.
 */

import { useLocation } from 'react-router-dom';
import { SistemicMarquee } from './SistemicMarquee';

export function SistemicOutro() {
  const { pathname } = useLocation();
  // En /acerca ya vive la landing completa de Sistemic con su CTA.
  if (pathname === '/acerca') return null;
  return <SistemicMarquee to="/acerca" />;
}
